module.exports = __webpack_public_path__ + "components/rewards/dogtag/static/icon-459aff26f32d199ab3ebebf089c8337b.svg";